import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { AlertsComponent } from "./common/alerts/alerts.component";

@Component({
  selector: "app-root",
  imports: [RouterOutlet, AlertsComponent],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})
export class AppComponent {
  title = "ca-platform";
}
